//* Libraries imports
import { useState, useEffect } from "react";
import { IconButton } from "@mui/material";

//* Componentes imports
import { Separator } from "@components/ui/separator";
import { PecasSection } from "./PecasSection";
import { FormSection } from "./FormSection";
import { AppointmentsSection } from "./AppointmentsSection";
import { IAServiceSection } from "./IAServiceSection";

type ApplicationSectionProps = {
  setAppointments: (appointments: any) => void;
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
  forms: any[];
  activity: any;
  handleFieldChange: (field: string, value: any) => void;
  templates: any[];
  techinicals: any[];
  categories: any[];
  documents: any[];
  saveFile: (file: any) => Promise<any>;
  error?: any;
};

export const ApplicationSection = ({
  setAppointments,
  selectedTab,
  setSelectedTab,
  forms,
  activity,
  handleFieldChange,
  templates,
  techinicals,
  categories,
  documents,
  saveFile,
  error,
}: ApplicationSectionProps) => {
  const [appointments, setAppointmentsApplication] = useState([]);

  useEffect(() => {
    setAppointments(appointments);
  }, [appointments, setAppointments]);

  return (
    <div id="aplicacoes" className="w-full">
      <div className="flex justify-center">
        <IconButton
          style={{
            borderRadius: 10,
            width: 65,
            height: 45,
            color: "grey",
            marginRight: 10,
          }}
          onClick={() => {
            setSelectedTab(0);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={100}
            style={{ paddingLeft: 5, marginRight: 5 }}
            height="100"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M17.6307 0.00157104C14.117 -0.0614313 10.1098 1.77539 7.57338 4.62475C5.14943 4.6705 2.78923 5.66429 1.05152 7.4021C0.950272 7.50185 0.914273 7.65111 0.958522 7.78612C1.00352 7.92187 1.12052 8.02012 1.26152 8.04037L4.15195 8.45439L3.79496 8.85416C3.66221 9.00266 3.66896 9.22842 3.80996 9.36943L8.6301 14.1899C8.70285 14.2626 8.79885 14.2994 8.8956 14.2994C8.98485 14.2994 9.07409 14.2679 9.14534 14.2041L9.54508 13.8471L9.95907 16.7377C9.97932 16.8787 10.0903 16.9822 10.2246 17.0272C10.2591 17.0385 10.2951 17.0437 10.3318 17.0437C10.4383 17.0437 10.5471 16.9972 10.6221 16.923C12.3358 15.2091 13.3295 12.8488 13.3752 10.4247C16.2274 7.88287 18.0791 3.87697 17.9974 0.367585C17.9921 0.168077 17.8309 0.00682124 17.6307 0.00157104ZM14.1747 6.47582C13.8095 6.84108 13.3295 7.02409 12.8488 7.02409C12.368 7.02409 11.888 6.84108 11.5228 6.47582C10.7923 5.74454 10.7923 4.55499 11.5228 3.82372C12.254 3.09244 13.4435 3.09244 14.1747 3.82372C14.906 4.55499 14.906 5.74529 14.1747 6.47582Z"
              fill={selectedTab === 0 ? "#1777CF" : "#7D8592"}
            />
            <path
              d="M2.043 12.6785C1.24052 13.4811 0.13879 17.1067 0.0157927 17.517C-0.0239564 17.649 0.0127928 17.7922 0.109541 17.8897C0.181539 17.9618 0.276787 18 0.375035 18C0.411034 18 0.447033 17.9948 0.483032 17.9843C0.893273 17.8612 4.51869 16.7595 5.32118 15.9569C6.22491 15.0531 6.22491 13.5823 5.32118 12.6785C4.4167 11.7748 2.94673 11.7755 2.043 12.6785Z"
              fill={selectedTab === 0 ? "#1777CF" : "#7D8592"}
            />
          </svg>
          <span style={{ fontSize: 16 }}>
            {String(Object.keys(activity?.techinicals || {}).length).padStart(
              2,
              "0",
            )}
          </span>
        </IconButton>
        <IconButton
          style={{
            borderRadius: 10,
            width: 65,
            height: 45,
            color: "grey",
            marginRight: 10,
          }}
          onClick={() => {
            setSelectedTab(1);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={100}
            style={{ paddingLeft: 5, marginRight: 5 }}
            height="100"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M3.05176e-05 18.0004H12.6799V13.0016C12.6799 12.8224 12.825 12.677 13.0045 12.677H18.0001V0H3.05176e-05V18.0004ZM2.91657 3.63975H15.0839C15.2634 3.63975 15.4085 3.78517 15.4085 3.96435C15.4085 4.14353 15.2634 4.28895 15.0839 4.28895H2.91657C2.73707 4.28895 2.59197 4.14353 2.59197 3.96435C2.59197 3.78517 2.73707 3.63975 2.91657 3.63975ZM2.91657 6.65205H15.0839C15.2634 6.65205 15.4085 6.79747 15.4085 6.97665C15.4085 7.15583 15.2634 7.30125 15.0839 7.30125H2.91657C2.73707 7.30125 2.59197 7.15583 2.59197 6.97665C2.59197 6.79747 2.73707 6.65205 2.91657 6.65205ZM2.91657 9.66434H15.0839C15.2634 9.66434 15.4085 9.80976 15.4085 9.98894C15.4085 10.1681 15.2634 10.3135 15.0839 10.3135H2.91657C2.73707 10.3135 2.59197 10.1681 2.59197 9.98894C2.59197 9.80976 2.73707 9.66434 2.91657 9.66434ZM2.91657 12.6766H9.65074C9.83025 12.6766 9.97534 12.8221 9.97534 13.0012C9.97534 13.1804 9.83025 13.3258 9.65074 13.3258H2.91657C2.73707 13.3258 2.59197 13.1804 2.59197 13.0012C2.59197 12.8221 2.73707 12.6766 2.91657 12.6766Z"
              fill={selectedTab === 1 ? "#1777CF" : "#7D8592"}
            />
            <path
              d="M17.5411 13.3258H13.3294V17.5379L17.5411 13.3258Z"
              fill={selectedTab === 1 ? "#1777CF" : "#7D8592"}
            />
          </svg>
          <span style={{ fontSize: 16 }}>
            {String(activity?.typeRefId === "" ? 0 : 1).padStart(2, "0")}
          </span>
        </IconButton>

        <IconButton
          style={{
            borderRadius: 10,
            width: 65,
            height: 45,
            color: "grey",
            marginRight: 10,
          }}
          onClick={() => {
            setSelectedTab(2);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={100}
            style={{ paddingLeft: 5, marginRight: 5 }}
            height="100"
            viewBox="0 0 18 16"
            fill="none"
          >
            <path
              d="M0.52656 12.8H14.3084C14.432 12.8 14.5515 12.7562 14.6463 12.6765C14.7786 12.5644 17.7982 9.9374 17.9824 4.26666H3.18091C2.99749 9.41417 0.216574 11.8336 0.187674 11.8578C0.0182484 12.0026 -0.0440864 12.239 0.0321357 12.4495C0.107831 12.6594 0.305101 12.8 0.52656 12.8Z"
              fill={selectedTab === 2 ? "#1777CF" : "#7D8592"}
            />
            <path
              d="M17.4726 1.06666H14.8358V0.533332C14.8358 0.234666 14.6037 0 14.3084 0C14.0131 0 13.781 0.234666 13.781 0.533332V1.06666H11.109V0.533332C11.109 0.234666 10.877 0 10.5817 0C10.2863 0 10.0543 0.234666 10.0543 0.533332V1.06666H7.41746V0.533332C7.41746 0.234666 7.18542 0 6.89009 0C6.59477 0 6.36272 0.234666 6.36272 0.533332V1.06666H3.72589C3.43056 1.06666 3.19852 1.30133 3.19852 1.6V3.19999H18V1.6C18 1.30133 17.7679 1.06666 17.4726 1.06666Z"
              fill={selectedTab === 2 ? "#1777CF" : "#7D8592"}
            />
            <path
              d="M15.3235 13.4943C15.0371 13.7354 14.6777 13.8667 14.3084 13.8667H3.19855V15.4667C3.19855 15.7615 3.43443 16 3.72592 16H17.4726C17.7641 16 18 15.7615 18 15.4667V9.48816C16.9832 12.0109 15.5644 13.2904 15.3235 13.4943Z"
              fill={selectedTab === 2 ? "#1777CF" : "#7D8592"}
            />
          </svg>
          <span style={{ fontSize: 16 }}>
            {String(appointments.length).padStart(2, "0")}
          </span>
        </IconButton>

        <IconButton
          style={{ borderRadius: 10, width: 65, height: 45, color: "grey" }}
          onClick={() => {
            setSelectedTab(3);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={100}
            style={{ paddingLeft: 5 }}
            height="100"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M10.332 1.314C10.332 2.0397 9.74369 2.628 9.018 2.628C8.29231 2.628 7.704 2.0397 7.704 1.314C7.704 0.588298 8.29231 0 9.018 0C9.74369 0 10.332 0.588298 10.332 1.314Z"
              fill={selectedTab === 3 ? "#1777CF" : "#7D8592"}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.018 2.628L6.768 2.628C4.79311 2.628 3.11773 3.91046 2.52926 5.688H2.448C1.09601 5.688 0 6.78402 0 8.136C0 9.48798 1.09601 10.584 2.448 10.584H2.50611C3.07271 12.3988 4.76654 13.716 6.768 13.716H11.268C13.2695 13.716 14.9633 12.3988 15.5299 10.584H15.552C16.904 10.584 18 9.48798 18 8.136C18 6.78402 16.904 5.688 15.552 5.688H15.5067C14.9183 3.91046 13.2429 2.628 11.268 2.628L9.018 2.628ZM13.3807 7.848C13.3807 8.77093 12.6325 9.51916 11.7095 9.51916C10.7865 9.51916 10.0383 8.77093 10.0383 7.848C10.0383 6.92503 10.7865 6.17681 11.7095 6.17681C12.6325 6.17681 13.3807 6.92503 13.3807 7.848ZM6.27916 9.51916C7.20212 9.51916 7.95035 8.77093 7.95035 7.848C7.95035 6.92503 7.20212 6.17681 6.27916 6.17681C5.35622 6.17681 4.608 6.92503 4.608 7.848C4.608 8.77093 5.35622 9.51916 6.27916 9.51916Z"
              fill={selectedTab === 3 ? "#1777CF" : "#7D8592"}
            />
            <path
              d="M3.23693 18C4.31543 15.9049 6.49937 14.472 9.018 14.472C11.5366 14.472 13.7206 15.9049 14.7991 18H3.23693Z"
              fill={selectedTab === 3 ? "#1777CF" : "#7D8592"}
            />
          </svg>
          <span style={{ fontSize: 16 }}>{String(0).padStart(2, "0")}</span>
        </IconButton>
      </div>

      <Separator className="mb-5" />

      <div hidden={selectedTab !== 0}>
        <PecasSection
          pecas={activity?.techinicals || {}}
          activity={activity}
          handleFieldChange={handleFieldChange}
          techinicals={techinicals}
          categories={categories}
        />
      </div>

      {activity && (
        <div hidden={selectedTab !== 1}>
          <FormSection
            handleFieldChange={handleFieldChange}
            activity={activity}
            forms={forms}
            error={error}
          />
        </div>
      )}

      <div hidden={selectedTab !== 2}>
        <AppointmentsSection
          setAppointments={(e) => setAppointmentsApplication(e)}
        />
      </div>

      <div hidden={selectedTab !== 3}>
        <IAServiceSection pecas={[]} />
      </div>
    </div>
  );
};
